import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TransitEditData } from '@e-origin/contracts';
import { Transit } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface UpdateTransitProps {
  transit: Partial<Transit>;
  refreshCustomerData?: boolean;
  overwriteTrace?: boolean;
}

export const useUpdateTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transit, refreshCustomerData, overwriteTrace }: UpdateTransitProps): Promise<Transit> => {
      const result = await apiClient.transit.updateTransit.mutation({
        body: { transit: transit as unknown as TransitEditData['transit'], refreshCustomerData, overwriteTrace },
      });
      if (result.status !== 200) throw result.body;
      return result.body.data as unknown as Transit;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['transit', data._id] });
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success('Transit saved successfully!');
    },
    onError: (error) => {
      const originalError = (error as any).response?.data?.originalError;
      showErrorToast(error, originalError || `Error saving the transit!`);
    },
  });
};
